import React from 'react';
import cx from 'classnames';
import { Button, ButtonProps, Checkbox } from '@blueprintjs/core';

import cls from './Checkbutton.module.css';

export interface CheckbuttonProps extends ButtonProps {
  className?: string;
  text: string;
  value: boolean;
  onChange: (nextValue: boolean) => void;
}

export function Checkbutton(props: CheckbuttonProps): React.ReactElement {
  const { className, large, text, value, onChange, ...restProps } = props;

  const onClick = (event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
    event.stopPropagation();
    event.preventDefault();
    onChange(!value);
  };
  const onCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    event.stopPropagation();
    onChange(!value);
  };

  return (
    <div>
      <Button {...restProps} className={cx(cls.button, className)} large={large} onClick={onClick}>
        <Checkbox
          className={cls.checkbox}
          large={large}
          inline
          checked={value}
          label={text}
          onChange={onCheckboxChange}
        />
      </Button>
    </div>
  );
}
